<template>
  <div>
    <div class="md-layout mb-10">
      <div class="md-layout-item md-size-100 flex justify-between mb-6">
        <span class="text-[#2d82b5] font-semibold">
          SRI&SMI for {{ info.full_name }}
        </span>
        <span class="text-sm">
          {{ $t("common.student_id") }}:
          <span class="font-semibold">{{ info.student_code }}</span>
          <span class="ml-4">
            {{ $t("common.grade") }}:
            <span class="font-semibold">{{ info.grade }}</span>
          </span>
        </span>
      </div>
      <div class="md-layout-item md-size-100" v-if="chartSri.length">
        <p class="font-medium text-sm mb-4">
          {{ $t("smi_sri.reading_comprehension_assessment") }} (SRI)
        </p>
        <div class="mb-10">
          <sri-smi-chart
            :chart-data-assessment="chartSri"
            type="SRI"
          ></sri-smi-chart>
        </div>
        <div class="md-layout">
          <div class="md-layout-item md-size-70 md-small-size-100">
            <table-proficiency-ranges
              type="SRI"
              class="mb-3"
            ></table-proficiency-ranges>
          </div>
          <div
            class="md-layout-item md-size-30 md-small-size-100 text-center font-medium"
          >
            <p class="mb-3">BR = {{ $t("smi_sri.beginning_reader") }}</p>
            <div class="flex justify-center">
              <div class="square mr-3"></div>
              {{ $t("smi_sri.proficient") }}
            </div>
          </div>
        </div>
        <p class="font-medium mb-3">
          {{ $t("smi_sri.detail_about_tests") }}
        </p>
        <md-table class="table-pdf-assessment">
          <md-table-row class="text-center">
            <md-table-cell>{{ $t("common.no") }}</md-table-cell>
            <md-table-cell>{{ $t("common.grade") }}</md-table-cell>
            <md-table-cell>{{ $t("smi_sri.test_date") }}</md-table-cell>
            <md-table-cell>{{ $t("smi_sri.lexile_scores") }}</md-table-cell>
            <md-table-cell>{{
              $t("smi_sri.total_time_per_test")
            }}</md-table-cell>
          </md-table-row>
          <md-table-row
            class="text-center"
            v-for="row in chartSri"
            :key="'Chart SRI' + row.noNumb"
          >
            <md-table-cell>{{ row.noNumb }}</md-table-cell>
            <md-table-cell>{{ row.grade }}</md-table-cell>
            <md-table-cell>{{ row.date }}</md-table-cell>
            <md-table-cell>{{ row.lexile_scores }}</md-table-cell>
            <md-table-cell>{{ row.total_time_per_test }}</md-table-cell>
          </md-table-row>
        </md-table>
      </div>
    </div>

    <div class="md-layout">
      <div class="md-layout-item md-size-100" v-if="chartSmi.length">
        <p class="font-medium text-sm mb-4">
          {{ $t("smi_sri.reading_comprehension_assessment") }} (SMI)
        </p>
        <div class="mb-10">
          <sri-smi-chart
            :chart-data-assessment="chartSmi"
            type="SMI"
          ></sri-smi-chart>
        </div>
        <div class="md-layout">
          <div class="md-layout-item md-size-70 md-small-size-100">
            <table-proficiency-ranges
              type="SMI"
              class="mb-3"
            ></table-proficiency-ranges>
          </div>
          <div
            class="md-layout-item md-size-30 md-small-size-100 text-center font-medium"
          >
            <p class="mb-3">BR = {{ $t("smi_sri.beginning_reader") }}</p>
            <div class="flex justify-center">
              <div class="square mr-3"></div>
              {{ $t("smi_sri.proficient") }}
            </div>
          </div>
        </div>
        <p class="font-medium mb-3">
          {{ $t("smi_sri.detail_about_tests") }}
        </p>
        <md-table class="table-pdf-assessment">
          <md-table-row class="text-center">
            <md-table-cell>{{ $t("common.no") }}</md-table-cell>
            <md-table-cell>{{ $t("common.grade") }}</md-table-cell>
            <md-table-cell>{{ $t("smi_sri.test_date") }}</md-table-cell>
            <md-table-cell>{{ $t("smi_sri.quantile_scores") }}</md-table-cell>
            <md-table-cell>{{ $t("smi_sri.performance_level") }}</md-table-cell>
          </md-table-row>
          <md-table-row
            class="text-center"
            v-for="row in chartSmi"
            :key="'Chart SMI' + row.noNumb"
          >
            <md-table-cell>{{ row.noNumb }}</md-table-cell>
            <md-table-cell>{{ row.grade }}</md-table-cell>
            <md-table-cell>{{ row.date }}</md-table-cell>
            <md-table-cell>{{ row.quantile_scores }}</md-table-cell>
            <md-table-cell>{{ row.performance_level }}</md-table-cell>
          </md-table-row>
        </md-table>
      </div>
    </div>
  </div>
</template>
<script>
import SriSmiChart from "./SriSmiChart";
import TableProficiencyRanges from "../../../../components/TableProficiencyRanges";

export default {
  name: "export-pdf-sri-smi",
  components: { TableProficiencyRanges, SriSmiChart },
  props: ["info", "chartSri", "chartSmi"]
};
</script>
<style lang="scss" scoped>
.square {
  height: 30px;
  width: 30px;
  background-color: #b0d58d;
}
</style>
